<template>
  <div
    class="rete-inline-fields"
    @pointerdown.stop
    @pointerup.stop
    @mousedown.stop
    @keydown.stop
    @keyup.stop
  >
    <div
      v-for="entry in fields"
      :key="entry.field.bindText"
      class="rete-inline-fields__field"
      :data-rete-field="entry.field.bindText"
      :class="{
        'rete-inline-fields__field--bool': entry.field.type === 'bool'
      }"
    >
      <template v-if="entry.kind === 'custom-attributes'">
        <div
          v-for="(attribute, index) in attributeList(entry.field)"
          :key="`attribute-${index}`"
          class="rete-inline-fields__attribute"
        >
          <label :for="`attribute-key-${_uid}-${index}`">Atributo</label>
          <pv-dropdown
            :inputId="`attribute-key-${_uid}-${index}`"
            ref="selects"
            v-model="attribute.atributo_customizavel"
            :options="attributeOptions(entry)"
            optionLabel="text"
            optionValue="value"
            :filter="true"
            placeholder="Selecione"
            emptyFilterMessage="Nenhum resultado"
            appendTo="body"
            @show="ajustarMenu"
            @change="onCustomAttributeChange(attribute, entry.options)"
          />
          <label :for="`attribute-value-${_uid}-${index}`">Valor</label>
          <pv-dropdown
            v-if="attribute.tipo === 'select'"
            :inputId="`attribute-value-${_uid}-${index}`"
            ref="selects"
            v-model="attribute.valor"
            :options="attributeValueOptions(attribute, entry.options)"
            optionLabel="text"
            optionValue="value"
            :filter="true"
            placeholder="Selecione"
            emptyFilterMessage="Nenhum resultado"
            appendTo="body"
            @show="ajustarMenu"
            @change="$emit('change', entry.field)"
          />
          <input
            v-else-if="attribute.tipo === 'text'"
            :id="`attribute-value-${_uid}-${index}`"
            v-model="attribute.valor"
            type="text"
            placeholder="Informe o valor"
            @input="$emit('change', entry.field)"
          />
          <button
            type="button"
            class="rete-inline-fields__remove"
            :aria-label="`Remover atributo ${index + 1}`"
            @click="removeAttribute(entry.field, index)"
          >
            <i class="fas fa-trash" aria-hidden="true"></i>
            Remover
          </button>
        </div>
        <button
          type="button"
          class="rete-inline-fields__add"
          @click="addAttribute(entry.field)"
        >
          <i class="fas fa-plus" aria-hidden="true"></i>
          Novo atributo
        </button>
      </template>
      <template v-else>
        <span v-if="entry.field.type !== 'bool'">
          {{ entry.label || entry.field.label }}
          <b v-if="entry.field.required">*</b>
        </span>
        <ReteBooleanField
          v-if="entry.field.type === 'bool'"
          v-model="entry.field.value"
          :field="entry.field"
          :label="entry.label"
          :compact="true"
          @change="$emit('change', entry.field)"
        />
        <pv-dropdown
          v-else-if="entry.field.type === 'select'"
          ref="selects"
          v-model="entry.field.value"
          :options="entry.options"
          optionLabel="text"
          optionValue="value"
          :filter="true"
          :showClear="!entry.field.required"
          :aria-label="entry.field.label"
          placeholder="Selecione"
          emptyFilterMessage="Nenhum resultado"
          appendTo="body"
          @show="ajustarMenu"
          @change="$emit('change', entry.field)"
        />
        <MultiSelect
          v-else-if="entry.field.type === 'multiSelect'"
          ref="selects"
          v-model="entry.field.value"
          :options="entry.options"
          optionLabel="text"
          :filter="true"
          :aria-label="entry.field.label"
          placeholder="Selecione"
          appendTo="body"
          @show="ajustarMenu"
          @change="$emit('change', entry.field)"
        />
        <textarea
          v-else-if="['textArea', 'textarea'].includes(entry.field.type)"
          v-model="entry.field.value"
          :readonly="entry.readonly"
          rows="2"
          :placeholder="entry.field.label"
          @input="$emit('change', entry.field)"
        ></textarea>
        <input
          v-else
          v-model="entry.field.value"
          type="text"
          :readonly="entry.readonly"
          :placeholder="entry.field.label"
          @input="$emit('change', entry.field)"
        />
        <small v-if="entry.readonly">Mensagem definida pelo template.</small>
      </template>
    </div>
  </div>
</template>

<script>
import MultiSelect from "primevue/multiselect";
import ReteBooleanField from "./ReteBooleanField.vue";
import { registerReteSelectDismissal } from "./reteSelectDismissal";

export default {
  components: { MultiSelect, ReteBooleanField },
  props: { fields: { type: Array, required: true } },
  methods: {
    attributeList(field) {
      return Array.isArray(field.value) ? field.value : [];
    },
    attributeOptions(entry) {
      return entry.options.filter(
        (option) => option.attribute_model === "conversation_attribute"
      );
    },
    attributeValueOptions(attribute, options) {
      const selected = options.find(
        (option) => option.value == attribute.atributo_customizavel
      );
      if (selected?.attribute_display_type !== "list") return [];
      return (selected.attribute_values || []).map((value) => ({
        value,
        text: value
      }));
    },
    onCustomAttributeChange(attribute, options) {
      const selected = options.find(
        (option) => option.value == attribute.atributo_customizavel
      );
      attribute.valor = "";
      attribute.tipo =
        selected?.attribute_display_type === "list" ? "select" : "text";
      this.$emit("change");
    },
    addAttribute(field) {
      if (!Array.isArray(field.value)) this.$set(field, "value", []);
      field.value.push({
        atributo_customizavel: "",
        valor: "",
        tipo: ""
      });
      this.$emit("change");
    },
    removeAttribute(field, index) {
      if (!Array.isArray(field.value)) return;
      field.value.splice(index, 1);
      this.$emit("change");
    },
    ajustarMenu() {
      (this.$refs.selects || []).forEach((select) => {
        const overlay = select.$refs.overlay;
        if (!overlay || !select.overlayVisible) return;
        registerReteSelectDismissal(select);
        overlay.style.zIndex = String(
          Math.max(3001, Number(overlay.style.zIndex) || 0)
        );
        overlay.classList.add("rete-inline-menu");
      });
    }
  }
};
</script>

<style lang="scss">
.rete-inline-fields {
  display: grid;
  gap: 9px;
  padding: 6px 11px 10px;
  .rete-inline-fields__field {
    color: #766d82;
    display: grid;
    font-size: 10px;
    font-weight: 600;
    gap: 4px;
    margin: 0;
    min-width: 0;
    b {
      color: #a95a71;
    }
    .rete-inline-fields__attribute {
      background: #fbfaff;
      border: 1px solid #e7e1ee;
      border-radius: 8px;
      display: grid;
      gap: 5px;
      margin-bottom: 6px;
      padding: 8px;
      > label {
        color: #766d82;
        font-size: 10px;
        font-weight: 600;
        margin: 0;
      }
      .p-dropdown {
        background: #fff;
        border: 1px solid #e7e1ee;
        border-radius: 6px;
        min-width: 0;
        width: 100%;
      }
      .p-dropdown-label {
        font-size: 11px;
        padding: 7px;
      }
      > input[type="text"] {
        background: #fff;
        border: 1px solid #e7e1ee;
        border-radius: 6px;
        box-sizing: border-box;
        color: #40364d;
        font: 11px Inter, Arial, sans-serif;
        min-width: 0;
        outline: none;
        padding: 7px;
        width: 100%;
        &:focus {
          border-color: #9470c2;
          box-shadow: 0 0 0 2px rgba(112, 71, 164, 0.1);
        }
      }
    }
    .rete-inline-fields__add,
    .rete-inline-fields__remove {
      align-items: center;
      border: 1px solid #e7e1ee;
      border-radius: 6px;
      cursor: pointer;
      display: inline-flex;
      font: 600 10px Inter, Arial, sans-serif;
      gap: 6px;
      justify-content: center;
      padding: 7px;
    }
    .rete-inline-fields__add {
      background: #f3eff9;
      color: #60378e;
      width: 100%;
    }
    .rete-inline-fields__remove {
      background: #fff;
      color: #a95a71;
    }
    small {
      font-size: 9px;
      font-weight: 400;
    }
    .rete-inline-fields__state {
      color: #947da9;
      display: block;
      margin-top: 3px;
    }
    > input[type="text"],
    > textarea {
      background: #fbfaff;
      border: 1px solid #e7e1ee;
      border-radius: 6px;
      box-sizing: border-box;
      color: #40364d;
      font: 11px Inter, Arial, sans-serif;
      min-width: 0;
      outline: none;
      padding: 7px;
      resize: vertical;
      width: 100%;
      &:focus {
        border-color: #9470c2;
        box-shadow: 0 0 0 2px rgba(112, 71, 164, 0.1);
      }
      &:read-only {
        background: #f3f0f7;
        color: #8a8098;
      }
    }
    .p-dropdown,
    .p-multiselect {
      background: #fbfaff;
      border: 1px solid #e7e1ee;
      border-radius: 6px;
      min-width: 0;
      width: 100%;
    }
    .p-dropdown-label,
    .p-multiselect-label {
      font-size: 11px;
      padding: 7px;
    }
    .p-dropdown-trigger,
    .p-multiselect-trigger {
      width: 26px;
    }
    .p-dropdown-label {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .rete-inline-fields__field--bool {
    align-items: center;
    display: flex;
    justify-content: space-between;
  }
  .rete-inline-fields__toggle {
    accent-color: #7047a4;
    cursor: pointer;
    height: 15px;
    margin: 0;
    width: 15px;
  }
}
.rete-inline-menu {
  border: 1px solid #e7e1ee;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(40, 25, 62, 0.16);
  font-size: 12px;
}
</style>
